import BasePlayerUi from '../player/basePlayerUI';
import logo from '../../../assets/images/onlyplay_logo_white.svg'
export default class LandscapeMobileUi extends BasePlayerUi {
  constructor({ config, partnerConfig }) {
    super({ config, partnerConfig });

    this._config = {
     ...this._config,
      offsets: {
        left_panel: {
          top: 0,
          left: 0,
        },
        right_panel: {
          top: 0,
          left: 0,
        },
        bottom_panel: {
          top: 0,
          left: 0,
        },
        tournaments_panel: {
          top: 0,
          left: 0,
          scale: 1,
        },
        freebets_panel: {
          top: 0,
          left: 0,
        }
      }
    };

    if (config && config.offsets) {
      this._config.offsets.left_panel = { ...this._config.offsets.left_panel, ...config.offsets.left_panel };
      this._config.offsets.right_panel = { ...this._config.offsets.right_panel, ...config.offsets.right_panel };
      this._config.offsets.bottom_panel = { ...this._config.offsets.bottom_panel, ...config.offsets.bottom_panel };
      this._config.offsets.tournaments_panel = { ...this._config.offsets.tournaments_panel, ...config.offsets.tournaments_panel };
      this._config.offsets.freebets_panel = { ...this._config.offsets.freebets_panel, ...config.offsets.freebets_panel };
    }

    this.init();
  }

  init(container) {
    super.init(container);
    this.root.setAttribute('data-orientation', 'landscape');
  }

  _getConstantMarkup() {
    return `<div class="ui-container__tournaments_label_container" data-orientation="landscape" style="--scale: ${this._config.offsets.tournaments_panel.scale}; top: ${window.OPWrapperService.ScaleManager.convertPxToRem(this._config.offsets.tournaments_panel.top)}rem; left: ${window.OPWrapperService.ScaleManager.convertPxToRem(this._config.offsets.tournaments_panel.left)}rem">
      <div id=${this.controllersContainersIds[this.controllerTypes.ECT_TOURNAMENTS_LABEL]}>
      </div>
    </div>

    <div class="ui-container__freebets_panel" id=${this.controllersContainersIds[this.controllerTypes.ECT_FREEBETS_PANEL]} style="position: fixed; width: 100%; bottom: 0; left: 0"></div>`
  }

  _getMarkup() {
    return `
    <div class="ui-container__tournaments_label_container" data-orientation="landscape" style="--scale: ${this._config.offsets.tournaments_panel.scale}; top: ${window.OPWrapperService.ScaleManager.convertPxToRem(this._config.offsets.tournaments_panel.top)}rem; left: ${window.OPWrapperService.ScaleManager.convertPxToRem(this._config.offsets.tournaments_panel.left)}rem">
      <div id=${this.controllersContainersIds[this.controllerTypes.ECT_TOURNAMENTS_LABEL]}>
      </div>
    </div>

<!--    modals    -->
    <div class="ui-container__bet_selector_container" data-orientation="landscape" data-device-type="mobile" style="padding: 0 ${window.OPWrapperService.ScaleManager.convertPxToRem(-this._config.offsets.right_panel.left)}rem ${window.OPWrapperService.ScaleManager.convertPxToRem(-this._config.offsets.bottom_panel.top)}rem 0">
      <div id=${this.controllersContainersIds[this.controllerTypes.ECT_BET_SELECTOR_TABLE]}>
      </div>
    </div>
    <div class="ui-container__auto_play_table" data-orientation="landscape" data-device-type="mobile" style="padding: 0 ${window.OPWrapperService.ScaleManager.convertPxToRem(-this._config.offsets.right_panel.left)}rem ${window.OPWrapperService.ScaleManager.convertPxToRem(-this._config.offsets.bottom_panel.top)}rem 0">
      <div id=${this.controllersContainersIds[this.controllerTypes.ECT_AUTO_PLAY_TABLE]}>
      </div>
    </div>
        

<!--    panels    -->
    <div class="ui-container__landscape-mobile">
      <div class="ui-container__landscape-mobile_left-panel">
        <div class="ui-container__landscape-mobile_left-panel_container" style="top: ${window.OPWrapperService.ScaleManager.convertPxToRem(this._config.offsets.left_panel.top)}rem; left: ${window.OPWrapperService.ScaleManager.convertPxToRem(this._config.offsets.left_panel.left)}rem"> 
          <!--    info    -->
          <div class="ui-container__controller_info" id=${this.controllersContainersIds[this.controllerTypes.ECT_INFO]}>
          </div>
        </div>
      </div>
      
      <div class="ui-container__landscape-mobile_bottom-panel">
        <div class="ui-container__landscape-mobile_bottom-panel_container" style="padding-bottom: ${window.OPWrapperService.ScaleManager.convertPxToRem(-this._config.offsets.bottom_panel.top)}rem; left: ${window.OPWrapperService.ScaleManager.convertPxToRem(this._config.offsets.bottom_panel.left)}rem">
          <div class="ui-container__freebets_panel" id=${this.controllersContainersIds[this.controllerTypes.ECT_FREEBETS_PANEL]} style="top: ${window.OPWrapperService.ScaleManager.convertPxToRem(this._config.offsets.freebets_panel.top)}rem; left: ${window.OPWrapperService.ScaleManager.convertPxToRem(this._config.offsets.freebets_panel.left)}rem"></div>
          <div>
            <!--      balance     -->
            <div class="ui-container__controller_balance" id=${this.controllersContainersIds[this.controllerTypes.ECT_BALANCE]}>
            </div>
            
            <!--      win / last win     -->
            <div class="top_container" id=${this.controllersContainersIds[this.controllerTypes.ECT_WIN]}>
            </div>
            
            <!--      bet     -->
            <div class="ui-container__controller_bet" id=${this.controllersContainersIds[this.controllerTypes.ECT_BET]}>
            </div>
          </div>
        </div>
      </div>
      
      <div class="ui-container__landscape-mobile_right-panel">
        <div class="ui-container__landscape-mobile_right-panel_container" style="top: ${window.OPWrapperService.ScaleManager.convertPxToRem(this._config.offsets.right_panel.top)}rem; left: ${window.OPWrapperService.ScaleManager.convertPxToRem(this._config.offsets.right_panel.left)}rem"> 
          <div class="ui-container__landscape-mobile_right-panel_container_top">
           <!--    fullscreen    -->
           <div class="ui-container__controller_fullscreen" id=${this.controllersContainersIds[this.controllerTypes.ECT_FULL_SCREEN]}>
           </div>
           <!--    sound    -->
           <div class="ui-container__controller_sound" id=${this.controllersContainersIds[this.controllerTypes.ECT_SOUND]}>
           </div>
           <!--    menu button    -->
           <div class="ui-container__controller_menu" id=${this.controllersContainersIds[this.controllerTypes.ECT_MENU]} data-orientation="landscape">
           </div> 
          </div>
          
          <!--    spin    -->
          <div class="ui-container__controller_spin" id=${this.controllersContainersIds[this.controllerTypes.ECT_SPIN]}>
          </div>
          
          <div class="ui-container__landscape-mobile_right-panel_container_bottom">
            <!--    autoplay    -->
            <div id=${this.controllersContainersIds[this.controllerTypes.ECT_AUTO_SPIN]} data-orientation="landscape">
            </div> 
            <!--    turbo play   -->
            <div id=${this.controllersContainersIds[this.controllerTypes.ECT_TURBO_SPIN]} data-orientation="landscape">
            </div>
            <!--    coins button     -->
            <div class="ui-container__controller_bet_selector" id=${this.controllersContainersIds[this.controllerTypes.ECT_BET_SELECT]} data-orientation="landscape">
            </div>
          </div>
 
        </div>
      </div>
    </div>`
  }
}
